import * as React from 'react';
import * as styles from './styles.css';

import { Text } from '../../Text';

export interface IItemProps {
  title: string;
  text: string;
  withLabel?: boolean;
}

export function Item({ title, text, withLabel }: IItemProps) {
  return (
    <div className={styles['item']}>
      <div className={styles['item-content']}>
        <div className={styles['item-title']}>
          <Text size="h4" bold>
            {title}
          </Text>
        </div>
        <div className={styles['item-text']}>{text}</div>
      </div>
      {withLabel && (
        <div className={styles['label']}>
          <Text size="small" color="white">
            Скоро
          </Text>
        </div>
      )}
    </div>
  );
}
